import styled from '@emotion/styled';
import { blue } from '~/theseus/styles/core';
import { spin } from '~/theseus/styles/keyframes';

interface Props {
  radius: number;
  color?: string;
  weight?: number;
}

const Spinner = styled.div<Props>`
  content: '';
  border-radius: 50%;
  border: ${props => props.weight || 4}px solid transparent;
  border-left-color: ${props => props.color || blue};

  animation: ${spin} 1s linear infinite;
  
  width: ${props => props.radius * 2}px;
  height: ${props => props.radius * 2}px;
`;

export default Spinner;
